class ArthereumTokenomics {
  /**
   * Calculates the stake boost based on the staked amount.
   * A linear scaling factor of 0.1 is applied.
   *
   * @param stakeAmount - The amount of PiCoins the user has staked.
   * @param stakeTimePeriodInMonth - The duration in months (fixed to 1 in this model).
   * @returns {number} - The calculated stake boost.
   */
  calculateStakeBoost(
    stakeAmount: number,
    stakeTimePeriodInMonth: number = 1
  ): number {
    const stakeScalingFactor = 0.1; // Controls the influence of staked amount on boost
    return stakeAmount * stakeScalingFactor; // Ensures minimum boost of 1
  }
}
export const arthereumTokenomics: ArthereumTokenomics =
  new ArthereumTokenomics();
